import { render, staticRenderFns } from "./AnswerContainer.vue?vue&type=template&id=6e6e79cf&scoped=true&lang=pug&"
import script from "./AnswerContainer.vue?vue&type=script&lang=js&"
export * from "./AnswerContainer.vue?vue&type=script&lang=js&"
import style0 from "./AnswerContainer.vue?vue&type=style&index=0&id=6e6e79cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6e79cf",
  null
  
)

export default component.exports